import  React from 'react';

const LoginPage = ({ theme }) => {
    return (
        null
    );
};

export default LoginPage;